export var KitType;
(function (KitType) {
    KitType[KitType["STANDARD"] = 1] = "STANDARD";
    KitType[KitType["DYNAMIC"] = 2] = "DYNAMIC";
})(KitType || (KitType = {}));
//# sourceMappingURL=kit-type.js.map